export class DriverRoundDifferencePouchOperationEntity {
  id?: string
  amount?: number
  roundDifference?: number
  fromPouchId?: number
  fromPouchDriverId?: number
  fromPouchDriverFullName?: string | null
  toPouchId?: number
  toPouchUserId?: string
  toPouchUserDisplayName?: string | null
  dateTime?: string
  description?: string | null
  totalRoundDifference?: number
}
